<script>
  import { myOrder, showPopup, loading, clearCart } from "../stores.js";

  import * as MessagingBL from "../bl/messaging-bl";
  import * as OrderDAL from "../dal/order-dal";
  import * as UserDAL from "../dal/user-dal";
  import CartItem from "./CartItem.svelte";
  import { createEventDispatcher } from "svelte";
  import { push } from "svelte-spa-router";


  const dispatch = createEventDispatcher();

  let circle;
  let status = "awaiting paymemt";
  let statusHeb = "ממתין לתשלום";

  let error = null;
  let showError = false;

  $:console.log($myOrder)

  function checkMessaging() {
    MessagingBL.initMessaging().catch((e) => {
      showPopup(
        "הרשמה לנוטיפיקציות נכשלה. לחץ אישור כדי לנסות שוב, או ביטול כדי לזרום הלאה",
        () => {
          setTimeout(function () {
            window.location.reload();
          });
        }
      );
      UserDAL.sendLog("MyOrder init messaging", e.toString());
    });
  }

  $: {
    if ($myOrder) {
      switch ($myOrder.status) {
        case "awaiting payment":
          statusHeb = "ממתין לתשלום";
          break;

        case "waiting":
          statusHeb = "ההזמנה התקבלה";
          clearCart();
          //once an order has been placed we should ask the user for notification permissions for order notifications
          if (window.cordova || !firebase.messaging.isSupported()) break;

          if (Notification.permission === "default") {
            showPopup(
              "כדי לקבל התראה כשההזמנה מוכנה, אשרו את בקשת ההרשאות בחלון הבא",
              () => {
                checkMessaging();
              }
            );
          } else if (Notification.permission === "granted") {
            checkMessaging();
          }

          break;

        case "preparing":
          statusHeb = "בהכנה";
          break;

        case "ready":
          statusHeb = $myOrder.deliveryDetails
            ? "המשלוח בדרך אלייך :)"
            : "הכל מוכן! <br> אפשר לבוא לאסוף :)";
          break;
      }
    }
  }

  $: {
    if ($myOrder && $myOrder.error && error != $myOrder.error) {
      error = $myOrder.error;
      showError = true;
    }
  }

</script>

<main>
  <div class="bg">
    {#if $myOrder}
      <div class="orderNumber">מספר הזמנה: #{$myOrder.orderId}</div>
      <div class="circle">
        <img src="images/logo.svg" alt="" />
        <svg viewBox="0 0 100 100">
          <circle
            class="circle"
            class:waitingPayment={$myOrder.status == 'awaiting payment'}
            class:waiting={$myOrder.status == 'waiting'}
            class:preparing={$myOrder.status == 'preparing'}
            class:ready={$myOrder.status == 'ready'}
            bind:this={circle}
            cx="50"
            cy="50"
            r="48"
            pathlength="100"
          />
        </svg>
        <div class="status">
          {@html statusHeb}
        </div>
        {#if $myOrder.status != 'ready'}
          <div class="progAnim">
            <div />
            <div />
            <div />
          </div>
        {/if}
      </div>

      <div class="title" on:click={push('/b/' + $myOrder.businessId)}>
        {$myOrder.businessTitle}
      </div>

      <div class="items">
        {#if $myOrder?.items}
          {#each $myOrder.items as item}
            <div class="item">
              <CartItem {item} showRemoveBtn={false} itemStyle={'order'} />
            </div>
          {/each}

          {#if $myOrder.deliveryDetails}
            <div class="deliveryCartItem">
              <div class="name">משלוח:</div>
              <hr />
              <span> {$myOrder.deliveryDetails.price} ₪</span>
            </div>
          {/if}
        {/if}
      </div>
      {#if $myOrder.notes}
        <div class="notes">הערות: <br /> <span>{$myOrder.notes}</span></div>
      {/if}
      <div class="sum">סה"כ: {$myOrder.sum} ₪</div>

      {#if $myOrder.status == 'awaiting payment'}
        <button
          class="payBtn"
          on:click={() => {
            dispatch('gotoPayment');
          }}
        >
          לתשלום
          <img src="images/card_icon.svg" alt="credit card icon" />
        </button>

        <div
          class="errorBtn"
          on:click={async () => {
            try {
              $loading = true;
              await OrderDAL.closeOrderBeforePay($myOrder.id);
              $loading = false;
            } catch (e) {
              $loading = false;
              showPopup('...משהו השתבש', () => {});
              UserDAL.sendLog('closeOrderBeforePay', e.toString());
            }
          }}
        >
          ביטול
        </div>
      {/if}
    {:else}
      <div class="empty">
        <div class="emptyBg">
          <span>הזמנה ריקה</span>
          <img src="images/logo_white.svg" alt="הזמנה ריקה" />
        </div>
      </div>
    {/if}
  </div>
</main>

{#if showError}
  <div class="errorMsgBg">
    <div class="errorMsg">
      <div class="title">ההזמנה בוטלה</div>
      <div class="errorReason">{error}</div>
      <div
        class="closeBtn"
        on:click={() => {
          showError = false;
        }}
      >
        סגור
      </div>
    </div>
  </div>
{/if}

<style>
  .deliveryCartItem {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-left: 25px;
    font-size: 16px;
    margin-bottom: 40px;
  }
  .deliveryCartItem > .name {
    display: list-item;
  }

  .deliveryCartItem > hr {
    width: 100%;
    border: none;
    border-bottom: 4px dotted gray;
    margin-left: 12px;
    margin-right: 12px;
    flex-grow: 1;
    min-width: 30px;
    height: 0px;
  }

  .deliveryCartItem > span {
    min-width: fit-content;
    font-weight: normal;
    font-size: 16px;
  }
  .payBtn {
    width: 200px;
    height: 50px;
    font-size: 20px;
    text-align: center;
    border: none;
    background: var(--blue1);
    color: white;
    border-radius: 7px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-around;
    box-shadow: 0 5px 0 #257db0e3;
    cursor: pointer;
  }

  .payBtn > img {
    opacity: 1;
    width: 40px;
  }

  main {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .bg {
    user-select: none;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #6e6e6e;
    text-align: center;
    max-width: 460px;
    margin-top: 30px;
    border-radius: 5px;
    box-shadow: 0 15px 15px #0000002e;
    margin-bottom: 40px;
    direction: rtl;
    padding: 20px;
    box-sizing: border-box;
  }

  .circle {
    position: relative;
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
    transition: stroke-dasharray 0.5s ease-out;
    transition-delay: 200ms;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 45px;
  }

  svg {
    position: absolute;
    transform: rotate(-90deg);
    fill: none;
    stroke-width: 4;
    stroke-linecap: round;
    stroke: var(--blue1);
    stroke-dasharray: 0 100;
    stroke-dashoffset: 0;
  }

  img {
    opacity: 0.07;
    width: 100%;
  }

  .orderNumber {
    margin-top: 45px;
    font-size: 40px;
    font-weight: 500;
  }

  .status {
    position: absolute;
    font-size: 30px;
    font-weight: 500;
    width: 100%;
    padding: 30px;
    box-sizing: border-box;
  }

  .waitingPayment {
    stroke-dasharray: 0 100;
  }

  .waiting {
    stroke-dasharray: 33 100;
  }

  .preparing {
    stroke-dasharray: 66 100;
  }

  .ready {
    stroke-dasharray: 100 100;
    stroke: var(--green1);
  }

  .progAnim {
    width: 100%;
    max-width: 90px;
    display: flex;
    justify-content: space-between;
    margin-top: 160px;
    position: absolute;
  }

  .progAnim > div {
    width: 8px;
    height: 8px;
    background: var(--blue1);
    border-radius: 30px;
    animation: grow 1.5s ease-in-out;
    animation-iteration-count: infinite;
    animation-delay: 100ms;
  }

  .progAnim > div:nth-child(2) {
    animation-delay: 200ms;
  }

  .progAnim > div:nth-child(3) {
    animation-delay: 300ms;
  }

  @keyframes grow {
    0% {
      transform: scale(1);
      background: var(--blue1);
    }

    50% {
      transform: scale(2.2);
      background: #85d2ff;
    }

    100% {
      transform: scale(1);
      background: var(--blue1);
    }
  }

  .title {
    font-size: 36px;
    font-family: "Rubik";
    margin-top: 30px;
    cursor: pointer;
    text-decoration: underline;
  }

  .items {
    width: 100%;
    max-width: 390px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    direction: rtl;
    background: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
  }

  .item {
    margin-bottom: 20px;
  }

  span {
    font-size: 26px;
    font-weight: 500;
    margin-right: 5px;
  }

  .sum {
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 30px;
  }

  .notes {
    font-size: 19px;
    text-align: right;
    width: 100%;
    padding-right: 60px;
    box-sizing: border-box;
    margin-top: 5px;
  }

  .notes > span {
    font-size: 20px;
    font-weight: 100;
    margin-right: 0;
    display: block;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    padding-top: 5px;
  }

  @media only screen and (max-width: 470px) {
    main {
      margin: 0;
      /* margin-bottom: 30px; */
    }
  }

  @media only screen and (max-width: 500px) {
    .bg {
      margin: 0;
      width: 100%;
      border-radius: 0;
      max-width: unset;
    }
  }

  .errorMsgBg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #0004;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    text-align: center;
  }

  .errorMsg {
    width: 100%;
    max-width: 460px;
    background: white;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    box-sizing: border-box;
    flex-direction: column;
  }

  .errorMsg > .title {
    font-size: 30px;
    margin: 0%;
    padding: 0;
  }

  .closeBtn {
    width: 50%;
    border: none;
    color: #fff;
    outline: none;
    border-radius: 3px;
    background-color: var(--red1);
    padding: 13px;
    margin: 5px;
    cursor: pointer;
    user-select: none;
    font-size: 16px;
  }

  .errorReason {
    background: #eaeaea;
    font-size: 20px;
    color: var(--grey1);
    width: 100%;
    text-align: center;
    margin: 20px;
    box-sizing: border-box;
    min-height: 90px;
    padding: 12px;
    border-radius: 3px;
    font-family: "Rubik";
  }

  .errorBtn {
    color: var(--red1);
    text-decoration: underline;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }

</style>
